import { render, staticRenderFns } from "./PriceChart.vue?vue&type=template&id=44b4e024"
import script from "./PriceChart.vue?vue&type=script&lang=js"
export * from "./PriceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports